/** Short mailbox prefix → Entra UPN. Mirrors serving/auth.py expand_login_hint.

 *  `jafar.k` becomes `jafar.k@transvolt.in`. A value that already has `@` is left
 *  alone so a full mailbox is never double-suffixed. Empty stays empty. */
export function expandLoginHint(value: string, domain: string): string {
  const raw = value.trim().toLowerCase()
  if (!raw) return ''
  if (raw.includes('@')) return raw
  const d = domain.trim().toLowerCase()
  return d ? `${raw}@${d}` : raw
}

/** Query for GET /auth/login from the console.

 *  `next` is the SPA path under `/app/`. `return_to` is this page's origin so the
 *  Microsoft callback (which can be on serving :8001) bounces back to Vite :5173.
 *  The server allowlists that origin; a foreign one is ignored. */
export function microsoftLoginParams(origin: string, pathname: string, search: string): URLSearchParams {
  const incoming = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const fromQuery = incoming.get('next')
  const next =
    fromQuery && fromQuery.startsWith('/') && !fromQuery.startsWith('//')
      ? fromQuery
      : pathname.startsWith('/app')
        ? pathname
        : '/app/'
  const qs = new URLSearchParams()
  qs.set('next', next)
  if (origin) qs.set('return_to', origin)
  return qs
}

/** Sign out: GET /auth/logout clears `fleet_session` only (not Microsoft) and 302s to /app/. */
export function logoutHref(origin: string): string {
  const qs = new URLSearchParams()
  if (origin) qs.set('return_to', origin)
  const q = qs.toString()
  return q ? `/auth/logout?${q}` : '/auth/logout'
}


/** Local accounts are stored as usernames, never as UPN. Mirrors
 *  serving/auth.py local_login_username. `admin` stays `admin`;
 *  `jafar.k@transvolt.in` becomes `jafar.k`; `depot.ops` stays `depot.ops`. */
export function localLoginUsername(value: string, domain: string): string {
  const raw = value.trim().toLowerCase()
  if (!raw) return ''
  const at = raw.lastIndexOf('@')
  if (at > 0 && raw.slice(at + 1) === domain.trim().toLowerCase()) {
    return raw.slice(0, at)
  }
  return raw
}
